/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { createDialogRoute } from '@gh/common-shared';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
import * as i2 from "../../../common-external-shared/components/ext-dialog/ext-dialog.component";
import * as i3 from "../../../common-external-shared/components/ext-dialog/ext-dialog-header.component";
import * as i4 from "../../../common-external-shared/components/ext-dialog/ext-dialog-content.component";
import * as i5 from "@angular/common";
import * as i6 from "../../../common-external-shared/components/ext-dialog/ext-dialog-button-bar.component";
import * as i7 from "@angular/material/button";
import * as i8 from "../../../core-type/pipes/type-format.pipe";
import * as i9 from "../../../core-mls/translation/translate.pipe";
function SupplierOrderInfoDialogComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var order_r1 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", order_r1.purchaseOrder, " ");
} }
var SupplierOrderInfoDialogComponent = /** @class */ (function () {
    function SupplierOrderInfoDialogComponent(dialogRef) {
        this.dialogRef = dialogRef;
    }
    Object.defineProperty(SupplierOrderInfoDialogComponent.prototype, "date", {
        get: function () {
            return this.input.date;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SupplierOrderInfoDialogComponent.prototype, "orders", {
        get: function () {
            return this.input.orders;
        },
        enumerable: true,
        configurable: true
    });
    SupplierOrderInfoDialogComponent.prototype.onClose = function () {
        this.dialogRef.close();
    };
    SupplierOrderInfoDialogComponent.ɵfac = function SupplierOrderInfoDialogComponent_Factory(t) { return new (t || SupplierOrderInfoDialogComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef)); };
    SupplierOrderInfoDialogComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SupplierOrderInfoDialogComponent, selectors: [["gh-supplier-order-info-dialog"]], decls: 9, vars: 8, consts: [["layout", "text", "forBreakpoint", "lt-xl"], [3, "title"], ["class", "order", 4, "ngFor", "ngForOf"], ["align", "center", 1, "buttons"], ["type", "button", "mat-raised-button", "", "color", "primary", 1, "large", 3, "click"], [1, "order"]], template: function SupplierOrderInfoDialogComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "gh-ext-dialog", 0);
            i0.ɵɵelement(1, "gh-ext-dialog-header", 1);
            i0.ɵɵpipe(2, "typeFormat");
            i0.ɵɵelementStart(3, "gh-ext-dialog-content");
            i0.ɵɵtemplate(4, SupplierOrderInfoDialogComponent_div_4_Template, 2, 1, "div", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "gh-ext-dialog-button-bar", 3);
            i0.ɵɵelementStart(6, "button", 4);
            i0.ɵɵlistener("click", function SupplierOrderInfoDialogComponent_Template_button_click_6_listener() { return ctx.onClose(); });
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("title", i0.ɵɵpipeBind2(2, 3, ctx.date, "DayMonthYear"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.orders);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 6, "lbl_show_calendar"));
        } }, directives: [i2.ExtDialogComponent, i3.ExtDialogHeaderComponent, i4.ExtDialogContentComponent, i5.NgForOf, i6.ExtDialogButtonBarComponent, i7.MatButton], pipes: [i8.TypeFormatPipe, i9.TranslatePipe], styles: ["[_nghost-%COMP%] {\n  overflow: hidden;\n  display: flex;\n  flex-direction: column; }\n  @media (max-width: 959px) {\n    [_nghost-%COMP%] {\n      width: 100vw;\n      min-height: 100vh; } }\n  @media (min-width: 960px) {\n    [_nghost-%COMP%] {\n      min-width: 600px;\n      min-height: auto; } }\n  [_nghost-%COMP%]   gh-ext-dialog-content[_ngcontent-%COMP%] {\n    padding-bottom: 0 !important; }\n  [_nghost-%COMP%]   .order[_ngcontent-%COMP%] {\n    border: 1px solid #eaeaea;\n    border-left-width: 0;\n    border-right-width: 0;\n    font-weight: bold;\n    padding: 20px 0 5px 10px; }\n    [_nghost-%COMP%]   .order[_ngcontent-%COMP%]:last-child {\n      border: none; }\n  [_nghost-%COMP%]   .buttons[_ngcontent-%COMP%] {\n    flex: 1;\n    align-items: flex-end;\n    padding-bottom: 50px; }"] });
    return SupplierOrderInfoDialogComponent;
}());
export { SupplierOrderInfoDialogComponent };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierOrderInfoDialogComponent, [{
        type: Component,
        args: [{
                selector: 'gh-supplier-order-info-dialog',
                templateUrl: 'supplier-order-info-dialog.component.html',
                styleUrls: ['supplier-order-info-dialog.component.scss'],
            }]
    }], function () { return [{ type: i1.MatDialogRef }]; }, null); })();
export var supplierOrderInfoDialogRoute = createDialogRoute({
    component: SupplierOrderInfoDialogComponent,
});
